<script setup lang="ts">
defineProps<{ collapsed?: boolean }>();
</script>

<template>
  <div :class="collapsed ? '' : 'tw:!px-2 tw:!pt-0.5 tw:!pb-2'">
    <div
      v-for="i in 9"
      :key="i"
      class="tw:flex tw:items-center tw:!my-0.5 tw:!rounded-xl tw:!py-2 tw:gap-2"
      :class="collapsed ? 'tw:justify-center' : 'tw:!px-2'"
    >
      <div
        class="loading-skeleton-on-dark tw:h-10 tw:w-10 tw:rounded-full tw:flex-shrink-0"
        :class="{ 'tw:!mr-2': !collapsed }"
      />
      <template v-if="!collapsed">
        <div class="tw:flex tw:flex-col tw:gap-1 tw:flex-1 tw:min-w-0">
          <div class="loading-skeleton-on-dark tw:h-3.5 tw:w-3/4 tw:rounded" />
          <div class="loading-skeleton-on-dark tw:h-2.5 tw:w-1/2 tw:rounded" />
        </div>
      </template>
    </div>
  </div>
</template>
